export default {
  inject: ['getI18n', 'getFunc'],
  computed: {
    i18n: {
      get() {
        return this.getI18n();
      }
    },
    funcView: vm => vm.getFunc()
  },
  watch: {
    i18n: {
      handler(val) {
        if (val && Object.keys(val).length) {
          this.initRule();
        }
      },
      immediate: true
    }
  }
};
